import { REDIRECT_TIME } from 'config/config';
import { fadeInAnimationLong, fadeInAnimationShort, progressAnimation, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, progressBarGradient, white, fontMontserrat } = styles;

export const SuccessScreenContainer = styled.div`
  border-radius: 0.5rem;
  background: ${progressBarGradient};
  text-align: center;
  color: ${white};
  padding-top: 5rem;
  padding-bottom: 3.25rem;
`;

export const SuccessScreenTitle = styled.div`
  font-size: 2rem;
  line-height: 1.25;
  color: ${white};
  font-weight: normal;
  height: 2.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
`;

export const SuccessScreenWrapper = styled.div`
  ${fadeInAnimationShort};
  animation: ${animationShort};
`;

export const SuccessScreenIcon = styled.div`
  img {
    ${fadeInAnimationLong};
    animation: ${animationLong};
    width: 12.5rem;
    height: 9.375rem;
  }
`;

export const SuccessScreenMessage = styled.div`
  font-size: 1.375rem;
  font-weight: 300;
  line-height: 1.32;
  height: 1.8125rem;
  margin-bottom: 0.1875rem;
`;

export const SuccessScreenDescription = styled.div`
  font-size: 0.75rem;
  line-height: 1.5rem;
  font-family: ${fontMontserrat};
  font-weight: 300;
  margin-bottom: 0.9375rem;
  color: ${white};
  font-weight: normal;
`;

export const SuccessScreenButton = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 0.6875rem;
  overflow: hidden;
  button {
    background: transparent;
    border: 0.0625rem solid ${white};
    border-radius: 0.6875rem;
    color: ${white};
    padding: 0.7rem 2.49rem;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.125rem;
    text-transform: uppercase;
    font-family: 'mBank';
    margin-top: 0;
    outline: none;
    cursor: pointer;
  }
  .timer {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 0.6875rem;
    animation: progress ${REDIRECT_TIME / 1000}s ease-in-out forwards;
    ${progressAnimation};
  }
`;
